import { useContext, useState, useEffect } from "react";
import {
  formContextTypes,
  notificationContextTypes,
  typeFormDto,
} from "../../utils/typeDefs";
import { apiUrls } from "../../utils/apiUrls";
import ReusableModal from "../../Components/generic/modal/reusableModal.component";
import FormRegTable from "../../Components/formRegTable/formRegTable.component";
import FormRegFunctionality from "../../Components/fromRegFuntionality/fromRegFunctionality";
import { FormContext } from "../../core/context/formContextProvider";
import FormsModal from "../../Components/generic/modal/formsModal.component";
import { postData } from "../../utils/reusables";
import { NotificationContext } from "../../core/context/notificationContextProvider";

type formProps = {
  title: string;
};

const Forms = ({ title }: formProps) => {
  const {
    formPageData,
    formCategoryData,
    setFormPageData,
    sortedCountryData,
    currentCountryId,
    setCurrentCountryId,
  } = useContext(FormContext) as formContextTypes;

  const { triggerNotification } = useContext(
    NotificationContext
  ) as notificationContextTypes;
  const addButton = "Add Form";

  // Modal
  const [openModal, setOpenModal] = useState(false);
  const [modalType, setModalType] = useState<string | null>(null);

  const handleOpenModal = () => {
    setModalType("form");
    setOpenModal(true);
  };

  const handleDelete = () => {
    setModalType("delete");
  };

  const handleEdit = () => {
    setModalType("edit");
  };

  const handleCloseModal = () => {
    setModalType(null);
    setOpenModal(false);
  };

  // Search
  const [search, setSearch] = useState("");
  const [searchData, setSearchData] = useState<typeFormDto[] | null>(
    formPageData
  );

  const filter = (item: React.FormEvent<HTMLInputElement>) => {
    const keyword = item.currentTarget.value;

    if (keyword === "") {
      setSearchData(formPageData);
    } else if (formPageData) {
      const result = formPageData.filter((val: typeFormDto) => {
        return val.title.toLowerCase().includes(keyword.toLowerCase());
      });
      setSearchData(result);
    }

    setSearch(keyword);
  };

  // Apply reviews
  const [reviewIds, setReviewIds] = useState<number[] | []>([]);
  const [reviewDate, setReviewDate] = useState<string | null>(null);

  const applyReviewData = () => {
    const dataToPost = {
      countryId: currentCountryId,
      ids: reviewIds,
      lastReviewDate: reviewDate,
    };

    if (reviewDate === null) {
      triggerNotification(false, "Review date not found");
    } else {
      setFormPageData(null);
      postData(apiUrls.form.applyReview, dataToPost).then((result) => {
        if (result.data.succeeded || result.status === 200) {
          setFormPageData(result.data.data);
          triggerNotification(true, result.data.message);
        } else {
          setFormPageData(formPageData);
          triggerNotification(false, "Data update failed");
        }
        setReviewIds([]);
        setReviewDate(null);
      });
    }
  };

  // Initial Table data
  useEffect(() => {
    setSearchData(formPageData);
  }, [formPageData]);

  // Select and deselect checkbox
  const handleCheckBoxAll = (value: boolean) => {
    const newData: (typeFormDto[] & { checked?: boolean }) | null = formPageData
      ? formPageData.map((item: typeFormDto) =>
          Object.assign(item, { checked: value })
        )
      : null;

    setSearchData(null);
    setFormPageData(newData);

    if (value && newData) {
      setReviewIds(newData.map((data: typeFormDto) => data.id));
    } else setReviewIds([]);
  };

  // Form data and functions
  const [urlId, setUrlId] = useState<number>(0);

  return (
    <section className="d-flex flex-column">
      <div className="content-box-title">
        <h1 className="page-title pb-3">{title}</h1>
        <div>
          <FormRegFunctionality
            data={formPageData}
            setData={setFormPageData}
            addButton={addButton}
            defaultId={null}
            currentCountryId={currentCountryId}
            setCurrentCountryId={setCurrentCountryId}
            sortedCountryData={sortedCountryData}
            reviewIds={reviewIds}
            search={search}
            searchData={searchData}
            setReviewDate={setReviewDate}
            handleOpenModal={handleOpenModal}
            handleCheckBoxAll={handleCheckBoxAll}
            applyReviewData={applyReviewData}
            filter={filter}
          />
        </div>

        <div className="tableHeight my-2 shadow rounded">
          <FormRegTable
            data={searchData}
            formCategoryData={formCategoryData}
            currentCountryId={currentCountryId}
            setSearchData={setFormPageData}
            reviewIds={reviewIds}
            setReviewIds={setReviewIds}
            url={`Form`}
            modalType={modalType}
            setModalType={setModalType}
            urlId={urlId}
            setUrlId={setUrlId}
            handleEdit={handleEdit}
            handleDelete={handleDelete}
            handleCheckBoxAll={handleCheckBoxAll}
          />
        </div>
      </div>

      <ReusableModal
        modalType={modalType}
        modalTitle="Add Form"
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        children={
          <FormsModal
            countryId={currentCountryId}
            modalType={modalType}
            formCategoryData={formCategoryData}
            handleCloseModal={handleCloseModal}
            url="Form"
            setData={setSearchData}
            loadData={false}
          />
        }
      />
    </section>
  );
};

export default Forms;
